export default class LoggedUserIndicator {
  static updateLoginIndicator(el: HTMLElement) {
    const cookieExists = document.cookie.includes("SERVICES_ACCESS_TOKEN=");

    if (cookieExists) {
      el.querySelector(".js-myaccount")?.classList.add("myaccount-logged-in");
    }
  }
}
